/* unplugin-vue-components disabled */import { ElSelect as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/option/style/css';
import { ElPagination as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/pagination/style/css';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  class: "page_box"
};
import { watch } from 'vue';
export default {
  __name: 'blkPagination',
  props: ['current_page', 'page_size', 'total'],
  emits: 'current-change',
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var handleCurrentChange = val => {
      emit('current-change', val);
    };
    var pageSizeList = ref([{
      value: 5,
      label: 5
    }, {
      value: 10,
      label: 10
    }, {
      value: 20,
      label: 20
    }, {
      value: 30,
      label: 30
    }]);
    var page = ref('');
    var page_size_child = ref(20);
    /**
     * 监听父组件传来的page并赋值给子组件的page
     */
    watch(() => {
      return props.current_page;
    }, val => {
      console.log('父组件传来的page===', val);
      page.value = val;
    }, {
      immediate: true,
      deep: true
    });
    /**
     * 监听子组件的page当发生改变时触发监听器给父组件
     */
    watch(() => {
      return page.value;
    }, val => {
      console.log('打印子组件的page====', val);
      emit('handleCurrentChange', val);
    }, {
      immediate: true
    });
    /**
     * 监听父组件传来的page_size并赋值给子组件的page_size_child
     */
    watch(() => {
      return props.page_size;
    }, val => {
      console.log('打印子组件的page====', val);
      page_size_child.value = val;
      // emit("handleCurrentChange", val);
    }, {
      immediate: true
    });
    /**
     * 监听子组件的page_size_child当发生改变时触发监听器给父组件
     */
    watch(() => {
      return page_size_child.value;
    }, val => {
      console.log('打印子组件的page====', val);
      emit('size-change', val);
    });
    var handle_change = val => {
      console.log('选中的页码是===', val);
      page_size_child.value = Number(val);
    };
    // watch(
    //   () => {
    //     return pageSizeList.value;
    //   },
    //   () => {
    //     console.log("打印pageSizeList====", pageSizeList.value);
    //   },
    //   { immediate: true, deep: true }
    // );

    return (_ctx, _cache) => {
      var _component_el_pagination = __unplugin_components_0;
      var _component_el_option = __unplugin_components_1;
      var _component_el_select = __unplugin_components_2;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_pagination, {
        "current-page": _unref(page),
        "onUpdate:currentPage": _cache[0] || (_cache[0] = $event => _isRef(page) ? page.value = $event : null),
        background: "",
        layout: "total,prev, pager, next",
        "page-size": _unref(page_size_child),
        total: props.total,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "total"]), _createVNode(_component_el_select, {
        modelValue: _unref(page_size_child),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(page_size_child) ? page_size_child.value = $event : null),
        class: "m-2",
        placeholder: "",
        size: "small",
        style: {
          "width": "80px",
          "margin": "0 5px",
          "text-align": "right"
        },
        "allow-create": "",
        filterable: "",
        onChange: handle_change
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageSizeList), item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _cache[2] || (_cache[2] = _createElementVNode("span", {
        style: {
          "font-size": "14px",
          "color": "#606266"
        }
      }, "条/页", -1))]);
    };
  }
};